import { render, staticRenderFns } from "./VaProgressBar.demo.vue?vue&type=template&id=4ec05761&"
import script from "./VaProgressBar.demo.vue?vue&type=script&lang=js&"
export * from "./VaProgressBar.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports